import { render, staticRenderFns } from "./disastertweet.vue?vue&type=template&id=51c77847&scoped=true&"
import script from "./disastertweet.vue?vue&type=script&lang=js&"
export * from "./disastertweet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c77847",
  null
  
)

export default component.exports